import React, { useEffect } from 'react';
import { BiSolidError } from 'react-icons/bi';
import styles from './ValidationMessages.module.scss';
import { MESSAGES_ALERT } from '../../../utils/constants';

const ValidationMessages = ({
  indexMetadata,
  enableDivisorOrStartingValue,
  setShouldSendLaunchDate,
}) => {
  const divisorEOD =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusDivisor &&
    indexMetadata?.calculation_setup === 'EOD' &&
    indexMetadata?.launch_point === 'EOD';

  const divisorIntradayImmediate =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusDivisor &&
    indexMetadata?.calculation_setup === 'EOD_INTRADAY' &&
    indexMetadata?.launch_point === 'IMMEDIATE';

  const divisorIntradayEOD =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusDivisor &&
    indexMetadata?.calculation_setup === 'EOD_INTRADAY' &&
    indexMetadata?.launch_point === 'EOD';

  const startingValueDeterminationPointImmediately =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusStarting &&
    indexMetadata?.starting_value &&
    indexMetadata?.calculation_setup === 'EOD' &&
    indexMetadata.divisor_determination_setup === 'IMMEDIATELY' &&
    indexMetadata?.launch_point === 'EOD';

  const startingValueDeterminationPointPreviousEOD =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusStarting &&
    indexMetadata?.starting_value &&
    indexMetadata?.calculation_setup === 'EOD_INTRADAY' &&
    indexMetadata.divisor_determination_setup === 'PREVIOUS_EOD' &&
    indexMetadata?.launch_point === 'IMMEDIATE';

  const startingValueImmediatelyImmediate =
    enableDivisorOrStartingValue?.[indexMetadata?.symbol]?.statusStarting &&
    indexMetadata?.starting_value &&
    indexMetadata?.calculation_setup === 'EOD_INTRADAY' &&
    indexMetadata.divisor_determination_setup === 'IMMEDIATELY' &&
    indexMetadata?.launch_point === 'IMMEDIATE';

  const theresAValidation = [
    divisorEOD,
    divisorIntradayImmediate,
    divisorIntradayEOD,
    startingValueDeterminationPointImmediately,
    startingValueDeterminationPointPreviousEOD,
    startingValueImmediatelyImmediate,
  ].some(Boolean);

  useEffect(() => {
    if (
      divisorIntradayImmediate ||
      startingValueDeterminationPointPreviousEOD ||
      startingValueImmediatelyImmediate
    ) {
      setShouldSendLaunchDate(false);
    } else {
      setShouldSendLaunchDate(true);
    }
  }, [
    indexMetadata?.calculation_setup,
    divisorIntradayImmediate,
    startingValueDeterminationPointPreviousEOD,
    startingValueImmediatelyImmediate,
    setShouldSendLaunchDate,
  ]);

  return (
    <>
      {theresAValidation && (
        <div className={styles.messageDivisorStartingValue}>
          <div className={styles.containerIconError}>
            <BiSolidError className="icon-error" style={{ fontSize: '2rem' }} />
          </div>
          {(divisorEOD || divisorIntradayImmediate || divisorIntradayEOD) && MESSAGES_ALERT.divisor}
          {startingValueDeterminationPointImmediately &&
            MESSAGES_ALERT.startingValueImmediatelyLaunchEOD}
          {startingValueDeterminationPointPreviousEOD &&
            MESSAGES_ALERT.startingValuePreviousEODLaunchImmediate}
          {startingValueImmediatelyImmediate &&
            MESSAGES_ALERT.startingValueImmediatelyLaunchImmediate}
        </div>
      )}
    </>
  );
};

export default ValidationMessages;
